<template>
    <div class="modal fade show add-note-modal" aria-labelledby="addNewCardTitle">
        <div class="modal-dialog modal-dialog-centered modal-md" ref="admissionModalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center px-1 my-1 align-item-center">
                            <h1 class="mb-0">Add Bill Dentition</h1>
                            <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0">
                
                <div class="modal-body d-flex justify-content-center align-items-center">
                    
                    <div class="col-12 d-flex justify-content-center flex-wrap">
                        <button
                                v-for="(item, index) in dentitionPertains" :key="index"
                                class="btn btn-outline-primary mx-1 mb-1"
                                @click="onSelectDentition(item)"
                                :class="item.is_billed ? 'btn-primary' : 'btn-outline-primary'"
                            >{{ getDentitionNumber(item.tooth_number) }}
                        </button>
                    </div>

                </div>
                <div class="modal-footer">
                    <div class="col-12 text-center">
                        <SubmitCancelBtn
                            @onSubmit="submit"
                            @onCancel="closeModal"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { cloneDeep } from 'lodash';
import { ref } from 'vue';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import SubmitCancelBtn from '@/components/atom/SubmitCancelBtn.vue';

const store = useStore();

const props = defineProps({
    singleItem: {
        type: Object || null,
        default: null
    }
});

const emit = defineEmits(['onSave']);

const dentitionPertains = ref([]);

const closeModal = () => {
    store.state.isModalOpen = false;
}

const submit = () => {
    props.singleItem.dentition_pertains = cloneDeep(dentitionPertains.value);
    closeModal();
    emit('onSave');
}

const getDentitionNumber = (position) => {
    return position.toUpperCase();
}

const onSelectDentition = (item) => {
    item.is_billed = !item.is_billed;
}

onMounted(() => {
    dentitionPertains.value = cloneDeep(props.singleItem.dentition_pertains);
})
</script>


<style scoped>
.modal-body{
    min-height: 200px;
}
.bg {
    background: aliceblue !important;
}
.modal-card{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    max-height: 280px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.add-note-modal {
    display: block; 
    background: #1c1d1c33
}

.permanent-partition-row {
    display: flex;
    border-radius: 5px;
    border: 1px solid gray;
    padding: 10px 11px 5px 0px;
    margin: 2px;
    justify-content: space-between;
}
.primary-partition-row {
    border-radius: 5px;
    border: 1px solid gray;
    padding: 10px 0px 5px 0px;
    margin-left: -3px;
    margin-right: 0px;
}
.num-btn {
    padding-left: .8rem;
    padding-right: .8rem;
}
.permanent-partition-col {
    padding-right: 0;
    margin-bottom: 8px;
}
.primary-partition-col {
    margin-bottom: 8px;
}
</style>